module.exports = __webpack_public_path__ + "media/images/area/feature/chugoku/related/zh-hant/1-9884572fbfadede30b28670111ad80b1.jpg";